export const BottomTabBar = ({ tabs, active, onChange }) => {
  return (
    <nav
      data-testid="bottom-tab-bar"
      className="fixed bottom-0 inset-x-0 z-40 bg-white border-t border-slate-200"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="max-w-md mx-auto flex justify-around">
        {tabs.map((t) => {
          const Icon = t.icon;
          const isActive = active === t.id;
          return (
            <button
              key={t.id}
              data-testid={`tab-${t.id}`}
              onClick={() => onChange(t.id)}
              className={`flex-1 flex flex-col items-center justify-center gap-1 py-2.5 min-h-[64px] transition-colors active:scale-95 ${
                isActive ? "text-primary" : "text-slate-400"
              }`}
            >
              <Icon className="h-6 w-6" strokeWidth={isActive ? 2.5 : 2} />
              <span className={`text-[11px] ${isActive ? "font-bold" : "font-medium"}`}>
                {t.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};
